import { matchN } from "../KnxProductDataTools/determineActorComObjectFunction";
import { ChannelType } from "../models/ChannelType";
import { noItx } from "../translationItx/itx";

// GVS 	iKnx Smart Touch Z10
// 1 - Switch
// 2 - Switch/Dimming
// 3 - Value send
// 4 - Open/Close Blind
// 5 - Roller Blind(without slat)
// 6 - Venetian Blind(with slat)
// 17 - Blind(open/close/stop)
// 18 - Blind(up/down/stop)
// 7 - Scene control

export function getChannelTypeForEnum(textEN: string): { channelType: ChannelType; isToggle?: boolean } {
  // if (["send"].includes(textEN)) {
  //   return ChannelType.Unknown;
  // } else

  textEN = textEN.toLocaleLowerCase();

  if (["toggle", "umschalten"].includes(textEN)) {
    return { channelType: ChannelType.Switch, isToggle: true };
  }

  if (matchN([noItx("switch indicator")], textEN)) {
    // GVS Z50
    return { channelType: ChannelType.StatusDisplaySwitch };
  }

  if (
    (matchN(["switch", "schalten"], textEN) && // no itx
      !matchN(
        [
          "send value", // no itx
          "short/long", // no itx
          "press/release", // no itx
          "dimming", // no itx
          "event counter", // no itx
          "step", // no itx
          "freischalten", // no itx
          "switching sequence", // no itx
          "/dim", // no itx
          "forced position", // no itx
          "mode", // no itx   // mwe 24.11. "operation mode" => "mode" für alte MDT Glastaster
        ],
        textEN,
      )) ||
    ["1 bit"].includes(textEN) // no itx
  ) {
    return { channelType: ChannelType.Switch };
  }

  // Staircase light
  if (
    matchN(["staircase function"], textEN) && // no itx
    !matchN([], textEN) // no itx
  ) {
    return { channelType: ChannelType.StaircaseLight };
  }

  // relative dimming: GVS CHTFB-3.0/6.x.yz
  if (
    [
      "dim", // no itx
      "dimmer", // no itx
      "dimming", // no itx
      "2-tasten-dimmen", // no itx
      "dimmen", // no itx
      "one button dimming", // no itx
      "relative dimming", // no itx
      "dimming and colour temperature", // no itx
      "switch/dimming", // GVS Z10  // no itx
      "switch/dim", // GVS Z10  // no itx
      "dimming absolute", // no itx
      "dimming brighter/darker", // no itx
      "dimming value transmitter", // no itx
    ].includes(textEN)
  ) {
    return { channelType: ChannelType.Dimmer };
  }

  if (
    matchN(
      [
        "jalousie", // no itx
        "blind", // no itx
        "blinds/shutter", // no itx
        "blind/shutter", // no itx
        "venetian blind", // venetian blind: GVS  // no itx
        "shading", // no itx Gira Taster 5013 00
      ],
      textEN,
    ) &&
    !matchN(
      [
        "without slat", // no itx
      ],
      textEN,
    )
  ) {
    return { channelType: ChannelType.Jalousie };
  }

  if (
    matchN(
      [
        "shutter", // no itx
        "rollladen", // no itx
        "rolladen", // no itx
        "rollo", // no itx
        "roller blind", // GVS Z10  // no itx
      ],
      textEN,
    )
  ) {
    return { channelType: ChannelType.Blind };
  }

  if (
    [
      "heating", // no itx
      "controller extension", // no itx Gira
    ].includes(textEN)
  ) {
    return { channelType: ChannelType.Heating };
  }

  // 9 - mode selection    // MDT GlasTaster

  if (["mode selection", "rtc operating mode switchover (1 byte)"].includes(textEN)) {
    return { channelType: ChannelType.OperationMode };
  }

  // Scenen haben weniger Verwechslungsgefahr s
  if (
    matchN(
      [
        "scene", // no itx
        "szene", // no itx
      ],
      textEN,
    )
  ) {
    return { channelType: ChannelType.Scene };
  }

  if (matchN([noItx("colour temperature"), noItx("tuneable white")], textEN)) {
    return { channelType: ChannelType.TuneableWhite };
  }

  if (matchN([noItx("hsv"), noItx("rgb dimming"), noItx("colour control")], textEN)) {
    return { channelType: ChannelType.Rgb };
  }

  if (matchN(["temperature"], textEN) && !matchN(["color", "tuneable", "white", "operating mode", "ntc"], textEN)) {
    return { channelType: ChannelType.Heating };
  }
  if (matchN(["status display"], textEN)) {
    return { channelType: ChannelType.StatusDisplaySwitch };
  }

  if (
    matchN(
      [
        "disabled", // no itx
        "inactive", // no itx
        "inaktiv", // no itx
        "no func", // no itx
        "nicht aktiv", // no itx
        "not active", // no itx
      ],
      textEN,
    )
  ) {
    return { channelType: ChannelType.Disabled };
  }

  // Code disabled 8.4.2025 MWE
  // if (
  //   matchN(
  //     [
  //       "value", // no itx
  //     ],
  //     textEN,
  //   )
  // ) {
  //   return { channelType: ChannelType.GenericValue };
  // }

  return { channelType: ChannelType.Unknown };
}
